import React from 'react'
import {makeStyles} from '@material-ui/core/styles'
import Modal from '@material-ui/core/Modal'
import {Link} from 'react-router-dom'
import {styled} from '@material-ui/core/styles'
import {Button as MuiButton, IconButton} from '@material-ui/core'
import CloseIcon from '@material-ui/icons/Close'

const useStyles = makeStyles(theme => ({
  modal: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center'
  },
  paper: {
    position: 'relative',
    backgroundColor: theme.palette.background.paper,
    padding: theme.spacing(2, 4, 3),
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    maxWidth: '37rem',
    '&:focus': {
      outlineColor: '#fff'
    }
  },
  closeButton: {
    position: 'absolute',
    top: theme.spacing(1),
    right: theme.spacing(1),
  }
}))

const Content = styled('div')(({theme}) => ({
  display: 'flex',
  margin: '1.5rem'
}))

const Text = styled('p')(({theme}) => ({
  margin: 0
}))

const StyledLink = styled(Link)(({theme}) => ({
  color: theme.palette.secondary.main,
  marginLeft: '0.28em'
}))

export default function ConfirmModal ({open, onClose}) {
  const classes = useStyles()

  return (
    <Modal className={classes.modal} open={open} onClose={onClose}>
      <div className={classes.paper}>
        <IconButton className={classes.closeButton} onClick={onClose} size='small' aria-label='close'>
          <CloseIcon fontSize='small' />
        </IconButton>
        <div style={{width: '100%'}}>          
          <h2 style={{margin: '2rem 0 1rem'}}>
            This feature is available only to FindAnLMS members.
          </h2>
        </div>
        <p style={{marginTop: 0}}>
								Create your <strong>FREE</strong> FindAnLMS account to view full application details, compare unlimited applications, save your favorite applications, request quotes, and enjoy unlimited access.                
        </p>
        <div
          style={{
            width: '100%',
            display: 'flex',
            justifyContent: 'space-around'
          }}
        >
          <MuiButton
            variant='contained'
            component={Link}
            to='/register'
            color='primary'
          >
            Sign up
          </MuiButton>
        </div>
        <Content style={{margin: '3rem 0 0'}}>
          <Text>Already have an account?</Text>
          <StyledLink to='/login'>Sign in</StyledLink>
        </Content>
      </div>
    </Modal>
  )
}
